import { render, staticRenderFns } from "./BroadcastDetailView.vue?vue&type=template&id=d339a548&"
import script from "./BroadcastDetailView.vue?vue&type=script&lang=ts&"
export * from "./BroadcastDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports